import { createSelector } from '@reduxjs/toolkit';
import { RootSelector } from '../../models/rootSelector';
import { getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import { UserAccessRight, userToString } from '../../../general/model';
import { PermissionModalShape } from './model';
import { CHNodeIsFolder, CHNode } from '../../../general/node';
import { getUsers } from '../app/selectors';
import { getCurrentNode } from '../breadcrumbs/selectors';

export const getPermissionButtonRelatedNode: RootSelector<CHNode | null> = createSelector(
  [getSelectedNodesInAllFolders, getCurrentNode],
  (selectedNodes, currentNode) => {
    if (selectedNodes.length) {
      if (
        selectedNodes.length > 1 ||
        !CHNodeIsFolder(selectedNodes[0]) ||
        !selectedNodes[0].perms.includes(UserAccessRight.admin)
      ) {
        return null;
      }
      return selectedNodes[0];
    }
    if (currentNode) {
      if (!CHNodeIsFolder(currentNode) || !currentNode.perms.includes(UserAccessRight.admin)) {
        return null;
      }
      return currentNode;
    }

    return null;
  },
);

export const getPermissionModal: RootSelector<PermissionModalShape> = (store) =>
  store.permissionModal;

export const getOpened: RootSelector<boolean> = createSelector(
  getPermissionModal,
  (modal) => modal.targetNodeID !== null,
);
export const getIsLoading: RootSelector<boolean> = createSelector(
  getPermissionModal,
  (modal) => modal.isLoading,
);
export const getPermissions: RootSelector<Record<UserAccessRight, boolean>> = createSelector(
  getPermissionModal,
  (modal) => modal.permissions,
);

export const getIsApplying: RootSelector<boolean> = createSelector(
  getPermissionModal,
  (modal) => modal.isApplying,
);
export const getSelectedsUsers = createSelector(getPermissionModal, (modal) => modal.selectedUsers);

export const getOptions = createSelector(getUsers, (users) =>
  (users ?? []).map((user) => ({
    text: userToString(user),
    value: user.id,
    __user: user,
  })),
);

export const getApplyButtonEnabled: RootSelector<boolean> = createSelector(
  [getSelectedsUsers, getPermissions, getIsApplying],
  (selectedUsers, permissions, applying) => {
    return Object.values(permissions).some((x) => x) && selectedUsers.length > 0 && !applying;
  },
);
